  /* var currentURL = window.location.href;  
  if (currentURL.includes('sort_by=')) {
    var urlParts = currentURL.split('sort_by=');
    var beforeSortBy = urlParts[0];
    var afterSortBy = urlParts[1];
    var questionMarkIndex = afterSortBy.indexOf('?');

    if (questionMarkIndex !== -1) {
      afterSortBy = afterSortBy.slice(questionMarkIndex + 1);
    } else {
      afterSortBy = '';
    }
    var newURL = beforeSortBy + afterSortBy;
    window.location.href = newURL;
  }
  if (currentURL.includes('page=')) {
    var urlParts = currentURL.split('page=');
    var beforeSortBy = urlParts[0];
    var afterSortBy = urlParts[1];
    var questionMarkIndex = afterSortBy.indexOf('?');

    if (questionMarkIndex !== -1) {
      afterSortBy = afterSortBy.slice(questionMarkIndex + 1);
    } else {
      afterSortBy = '';
    }
    var newURL = beforeSortBy + afterSortBy;
    window.location.href = newURL;
  } */
  // Not prefer to this solution
  // else if((currentURL.includes('q='))) {
  //   var urlParts = currentURL.split('q=');
  //   var beforeSortBy = urlParts[0];
  //   var afterSortBy = urlParts[1];
  //   var questionMarkIndex = afterSortBy.indexOf('?');

  //   if (questionMarkIndex !== -1) {
  //     afterSortBy = afterSortBy.slice(questionMarkIndex + 1);
  //   } else {
  //     afterSortBy = '';
  //   }
  //   var newURL = beforeSortBy + afterSortBy;
  //   window.location.href = newURL;
  // }
    $(document).submit(function(e){
    e.preventDefault();
  });